// Keep the public landing independent from authenticated sessions and product SDKs.
const base = import.meta.env.BASE_URL.replace(/\/$/, "");
const pathname = window.location.pathname;
const isLanding = pathname === `${base}/` || pathname === base;
if (isLanding) {
  void Promise.all([import("react-dom/client"), import("./landing/LandingPage")]).then(
    ([{ createRoot, hydrateRoot }, { LandingPage }]) => {
      const root = document.getElementById("root")!;
      if (root.hasChildNodes()) hydrateRoot(root, <LandingPage />);
      else createRoot(root).render(<LandingPage />);
    },
  );
} else {
  // Product routes retain their original session, styles and authorization flow.
  document.title = "Flex Traffic — рабочее пространство";
  document.querySelector('meta[name="robots"]')?.setAttribute("content", "noindex,nofollow");
  document.querySelector('link[rel="canonical"]')?.remove();
  document.getElementById("root")!.replaceChildren();
  void import("./workspace");
}
